import React, { memo, useEffect, useRef, useState } from 'react';

interface IProps {
  images: string[];
  w?: number;
  h?: number;
}

const ImageMerger: React.FC<IProps> = memo(({ images, w = 260, h = 193 }) => {
  const [mergedImage, setMergedImage] = useState(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    if (images.length === 0) return;

    const canvas: any = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const imgElements = images.map((src) => {
      const img = new Image();
      img.src = src;
      img.crossOrigin = 'anonymous';
      return img;
    });

    let loadedCount = 0;
    imgElements.forEach((img, index) => {
      img.onload = () => {
        loadedCount += 1;
        if (loadedCount === imgElements.length) {
          // 每张图片的宽高固定为 260px 和 193px
          const width = w;
          const height = h;

          // 获取设备的像素比
          const dpr = window.devicePixelRatio;

          // 设置画布的宽度和高度
          canvas.width = width * dpr;
          canvas.height = height * dpr;

          // 缩放 ctx
          ctx.scale(dpr, dpr)

          // 清空画布并设置透明背景
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.globalCompositeOperation = 'source-over';


          imgElements.forEach((img, index) => {
            // 绘制每张图片，统一设置大小为 260x193
            ctx.drawImage(img, 0, 0, width, height);
          });

          // 生成合成后的图片
          const dataUrl = canvas.toDataURL('image/png');
          setMergedImage(dataUrl);
        }
      };
    });
  }, [images]);

  return (
    <div>
      <canvas ref={canvasRef} style={{ display: 'none' }} />
      {mergedImage && <img src={mergedImage} alt="Merged" loading="lazy" style={{ width: `${w}px`, height: `${h}px` }} />}
    </div>
  );
});

export default ImageMerger;
